import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Loading from "../../shared/loading";
import SortableTH from "../../../src/View/UI/SortableTH/SortableTH";
import { getTaskAdminTemplateDetailsPath } from "../../../src/View/Pages/Admin/Task/TaskTemplate/AdminTaskTemplateRoutes";
const renderListRow = (template) => (_jsxs("tr", { children: [_jsx("td", { children: template.id }), _jsx("td", { children: template.id ? (_jsx("a", { href: getTaskAdminTemplateDetailsPath(template.id), children: template.templateTitle })) : (template.templateTitle) }), _jsx("td", { children: template.numberOfTasksWithThisTemplate }), _jsx("td", { className: "text-center", children: _jsx("span", { className: template.enabled ? "badge badge-success" : "badge badge-secondary", children: template.enabled ? "Yes" : "No" }) }), _jsx("td", { className: "text-center", children: _jsx("span", { className: template.isKeyEngagement
                    ? "badge badge-success"
                    : "badge badge-secondary", children: template.isKeyEngagement ? "Yes" : "No" }) }), _jsx("td", { children: template.modifiedByPerson
                ? template.modifiedByPerson.fullName
                : "Could not find who last modified this template" }), _jsx("td", { children: template.modifiedDate
                ? template.modifiedDate.toLocaleString()
                : "Could not find modified date" })] }, template.id));
const renderList = (templates, setSort) => {
    if (!templates.length) {
        return (_jsx("div", { className: "font-italic", children: "No Task Templates found. Press the \"New\" button to create one." }));
    }
    const tableHeaders = [
        {
            id: "id",
            name: "Id",
        },
        {
            id: "title",
            name: "Title",
        },
        {
            id: "taskEntities.size",
            name: "Tasks",
        },
        {
            id: "info.enabled",
            name: "Enabled",
        },
        { id: "isKeyEngagement", name: "Key Engagement" },
        { id: "modifiedByPerson", name: "Modified By" },
        { id: "modifiedDate", name: "Modified Date" },
    ];
    return (_jsx("div", { className: "table-responsive", children: _jsxs("table", { className: "table table-striped table-hover table-bordered", children: [_jsx("thead", { children: _jsx("tr", { children: tableHeaders.map(({ id, name }) => (_jsx(SortableTH, { 
                            // No sort indicators for now
                            sort: null, onClick: () => setSort(id), children: name }, id))) }) }), _jsx("tbody", { children: templates.map(renderListRow) })] }) }));
};
export default function TaskTemplateList(props) {
    if (props.hasError) {
        return (_jsx("div", { className: "alert alert-danger", children: typeof props.errorMessage === "string"
                ? props.errorMessage
                : "Sorry, there was an error loading templates" }));
    }
    if (props.isLoading) {
        return _jsx(Loading, { isLoading: true });
    }
    if (props.templates) {
        return renderList(props.templates, props.setSort);
    }
    return (_jsx("div", { children: "There aren't any templates! Click the 'New' button to make one." }));
}
